module.exports = __webpack_public_path__ + "static/media/tsc-cards.d7652f14.png";